import { Component, computed, ElementRef, HostListener, inject, signal } from '@angular/core';
import { TranslateService } from './translate.service';
import { TranslateLanguage } from './translate.interface';

/** ปุ่มเลือกภาษา: <app-language-switcher /> */
@Component({
  selector: 'app-language-switcher',
  template: `
    @if (languages().length > 1) {
    <div class="relative">
      <button type="button"
        class="flex items-center gap-1.5 rounded-xl bg-slate-50 hover:bg-slate-100 active:bg-slate-200 transition-colors px-2.5 py-2 border border-slate-100"
        (click)="open.set(!open())">
        @if (current()?.picture) {
        <img class="w-5 h-5 rounded-full object-cover" [src]="current()!.picture" [alt]="current()!.code" />
        }
        <span class="text-[11px] font-bold text-slate-700 uppercase">{{ current()?.code }}</span>
        <span class="material-symbols-outlined text-slate-400" style="font-size:1rem">expand_more</span>
      </button>
      @if (open()) {
      <div class="absolute right-0 mt-1.5 min-w-[150px] rounded-xl bg-white shadow-xl border border-slate-100 py-1 z-50">
        @for (item of languages(); track item.id) {
        <button type="button"
          class="w-full flex items-center gap-2.5 px-3 py-2 text-left text-[13px] hover:bg-slate-50"
          [class.font-bold]="item.id === current()?.id"
          [class.text-blue-600]="item.id === current()?.id"
          [class.text-slate-700]="item.id !== current()?.id"
          (click)="select(item)">
          @if (item.picture) {
          <img class="w-5 h-5 rounded-full object-cover" [src]="item.picture" [alt]="item.code" />
          }
          <span>{{ item.name }}</span>
        </button>
        }
      </div>
      }
    </div>
    }
  `,
})
export class LanguageSwitcher {
  private translate = inject(TranslateService);
  private el = inject(ElementRef);

  readonly languages = this.translate.languages;
  readonly current = computed(() => {
    const lang = this.translate.language();
    return this.languages().find(m => m.id === lang?.id) ?? lang;
  });
  readonly open = signal(false);

  select(item: TranslateLanguage) {
    this.translate.setLanguage(item);
    this.open.set(false);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(ev: Event) {
    if (!this.el.nativeElement.contains(ev.target)) this.open.set(false);
  }
}
